import { PhoneNumberUtil } from "google-libphonenumber";
import { Phone, EmailAddress } from "../core";
import moment from "moment";

export const ValidatePhoneNumber = (phoneNumber: string) => {
  phoneNumber = phoneNumber.includes("+") ? phoneNumber : `+${phoneNumber}`;
  let valid = false;

  try {
    const phoneUtil = PhoneNumberUtil.getInstance();
    valid = phoneUtil.isValidNumber(phoneUtil.parse(phoneNumber));
  } catch (e) {
    valid = false;
  }
  return valid;
};

export const ValidateEmail = (mail: string) => {
  if (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/.test(mail)) {
    return true;
  }

  return false;
};

export const CheckPhoneNumberEmpty = (phoneNumber: string) => {
  let valid = false;
  phoneNumber = phoneNumber.includes("+") ? phoneNumber : `+${phoneNumber}`;
  try {
    const phoneUtil = PhoneNumberUtil.getInstance();
    const countryCode = phoneUtil.parse(phoneNumber).getCountryCode();

    valid = phoneNumber.replace(countryCode ? countryCode.toString() : "", "")
      ? true
      : false;
  } catch (e) {
    valid = false;
  }
  return valid;
};

export const ValidatePhoneNumberRegEx = (
  phoneNumber: string,
  phoneType?: string
) => {
  phoneNumber = phoneNumber.includes("+") ? phoneNumber : `+${phoneNumber}`;
  let phoneLength = 0;
  let countryCode: any = '';
  try {
    const phoneUtil = PhoneNumberUtil.getInstance();
    const parsedNumber = phoneUtil.parse(phoneNumber);
    countryCode = parsedNumber.getCountryCode();
    phoneLength = phoneNumber.replace(
      countryCode ? `+${countryCode.toString()}` : "",
      ""
    )?.length;
    return phoneUtil.isPossibleNumber(parsedNumber);
    // const regionCode = phoneUtil.getRegionCodeForCountryCode(countryCode)
    // const isValid = phoneUtil.isPossibleNumberString(phoneNumber, regionCode);
    // const strict = phoneUtil.isValidNumber(parsedNumber);
  } catch (e) {
    return false;
  } 
  
  // if (/^\+[1-9][0-9]{8,12}$/.test(phoneNumber) && countryCode === 91 && phoneLength !== 10) {
  //   return false;
  // }

  // if (/^\+[1-9]{1}[0-9]{8,12}$/.test(phoneNumber) && phoneLength > 9) {
  //   return true;
  // }

  // return false;
};

export const ValidatePhoneNumberArray = (phones: Phone[]) => {
  let notValidCount = 0;
  phones?.forEach((item: { phone: string }) => {
    if (!Validate965DigitPhoneNumber(item.phone)) {
      notValidCount = notValidCount + 1;
    }
  });

  return notValidCount > 0 ? false : true;
};

export const ValidateEmailArray = (emails: EmailAddress[]) => {
  let notValidCount = 0;
  emails?.forEach((item: { email: string }) => {
    if (!ValidateEmail(item.email)) {
      notValidCount = notValidCount + 1;
    }
  });

  return notValidCount > 0 ? false : true;
};

export const ValidateString = (value: string) => {
  if (/^[A-Za-z. ]+$/.test(value?.trim())) {
    return true;
  }

  return false;
};

export const ValidateNumber = (phoneNumber: string) => {
  phoneNumber = phoneNumber.includes("+")
    ? phoneNumber.replace("+", "")
    : phoneNumber;
  if (/^\d{7,16}$/.test(phoneNumber)) {
    return true;
  }

  return false;
};

export const ValidateInteger = (value: string) => {
  if (/^\d*\.?\d*$/.test(value)) {
    return true;
  }

  return false;
};

export const ValidateDigit = (value: string) => {
  if (/^\d{7,16}$/.test(value)) {
    return true;
  }

  return false;
};

export const ValidateAlphabets = (value: string) => {
  if (/^[A-Za-z\u0600-\u06FF ]+$/.test(value?.trim())) {
    return true;
  }

  return false;
};

export const ValidateDigitString = (value: string) => {
  if (/[^A-Za-z0-9]+/.test(value?.trim())) {
    return true;
  }

  return false;
};

export const Validate8DigitPhoneNumber = (phoneNumber: string) => {
  phoneNumber =
    phoneNumber &&
    (phoneNumber.startsWith("91") || phoneNumber.startsWith("+91"))
      ? phoneNumber
      : `91${phoneNumber}`;
  phoneNumber = phoneNumber.includes("+") ? phoneNumber : `+${phoneNumber}`;
  let phoneLength = 0;
  try {
    phoneLength = phoneNumber.replace(`+91`, "")?.length;
  } catch (e) {
    return false;
  }

  if (/^\+[1-9]{1}[0-9]{8,12}$/.test(phoneNumber) && phoneLength === 10) {
    return true;
  }

  return false;
};

export const Validate965DigitPhoneNumber = (phoneNumber: string) => {
  if (!(phoneNumber.startsWith("91") || phoneNumber.startsWith("+91"))) {
    return ValidatePhoneNumberRegEx(phoneNumber);
  }

  phoneNumber =
    phoneNumber &&
    (phoneNumber.startsWith("91") || phoneNumber.startsWith("+91"))
      ? phoneNumber
      : `91${phoneNumber}`;
  phoneNumber = phoneNumber.includes("+") ? phoneNumber : `+${phoneNumber}`;
  let phoneLength = 0;
  try {
    phoneLength = phoneNumber.replace(`+91`, "")?.length;
  } catch (e) {
    return false;
  }

  if (/^\+[1-9]{1}[0-9]{8,12}$/.test(phoneNumber) && phoneLength === 10) {
    return true;
  }

  return false;
};

export const ExcelDateTransform = (excelDate: string | number) => {
  const date = moment(
    new Date(Math.round((Number(excelDate) - 25569) * 86400 * 1000))
  );
  const dateWithNewFormat = date.format("YYYY-MM-DD");
  return dateWithNewFormat;
};

export const ExcelDateTransformV2 = (excelDate: string | number) => {
  const date = excelDate
    ? !isNaN(Number(excelDate))
      ? convertExcelDateToJSDate(Number(excelDate))
      : new Date(excelDate?.toString())
    : undefined;

  const dateWithNewFormat = date
    ? moment(date).format("YYYY-MM-DD")
    : undefined;
  return dateWithNewFormat;
};

export const convertExcelDateToJSDate = (serial: number): Date => {
  const utcDays = Math.floor(serial - 25569);
  const utcValue = utcDays * 86400;
  const dateInfo = new Date(utcValue * 1000);

  const fractionalDay = serial - Math.floor(serial) + 0.0000001;

  let totalSeconds = Math.floor(86400 * fractionalDay);

  const seconds = totalSeconds % 60;

  totalSeconds -= seconds;

  const hours = Math.floor(totalSeconds / (60 * 60));
  const minutes = Math.floor(totalSeconds / 60) % 60;

  return new Date(
    dateInfo.getFullYear(),
    dateInfo.getMonth(),
    dateInfo.getDate(),
    hours,
    minutes,
    seconds
  );
};

export const convertExcelDateToJSDateV2 = (serial: string): Date => {
  const [day, month, year] = serial?.split("-");

  return new Date(+year, Number(month) - 1, +day);
};

export const ValidateGST=(value:string)=> /^[a-zA-Z0-9]{15}$/.test(value);

export const ValidateAlphaNumeric=(value:string)=> /^[a-zA-Z0-9]+$/.test(value);